/* ============================================================================
   Ypersoa — Module 1 : Sync couleur ↔ image héro (autonome)
   - Au change d'option du form produit : swap de l'image principale avec fondu
   - Préchargement de l'image avant le swap (~150ms)
   - Mise à jour de ?variant=XXX dans l'URL sans reload (history.replaceState)
   - Dispatch d'un event custom `ypersoa:variant-change` (detail = variant)
   Sélecteurs défensifs : élément manquant = warning console [Ypersoa], jamais de crash.
   Ce module ne dépend d'aucun CSS ni du drawer : il peut être déployé seul.
   ========================================================================== */
(function () {
  'use strict';

  var LOG = '[Ypersoa]';
  var FADE_MS = 150;

  /* ── Lecture du product JSON ───────────────────────────────────────────
     Priorité : [data-product-json] (standard). Fallback : /products/handle.js */
  function loadProduct() {
    var node = document.querySelector('[data-product-json]');
    if (node) {
      try {
        return Promise.resolve(JSON.parse(node.textContent));
      } catch (e) {
        console.warn(LOG, 'product JSON illisible dans [data-product-json], fallback fetch.', e);
      }
    }
    var canonical = document.querySelector('link[rel="canonical"]');
    var path = canonical ? canonical.getAttribute('href') : window.location.pathname;
    var handle = path.split('/products/').pop().split('?')[0].split('#')[0];
    if (!handle) return Promise.reject(new Error('handle produit introuvable'));
    return fetch('/products/' + handle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('GET /products/' + handle + '.js → ' + r.status);
        return r.json();
      });
  }

  /* ── Form produit principal ────────────────────────────────────────────── */
  function findForm() {
    return document.querySelector('form[action*="/cart/add"]') ||
           document.querySelector('[data-type="add-to-cart-form"]');
  }

  /* ── Image héro (image principale de la galerie PDP) ─────────────────────── */
  function findHeroImage() {
    return document.querySelector('.product__stage-item.is-active img') ||
           document.querySelector('media-gallery .product__media img') ||
           document.querySelector('.product__gallery-container img') ||
           document.querySelector('.product__media img');
  }

  /* ── Variante sélectionnée d'après les options du form ───────────────────── */
  function getSelectedVariant(product, form) {
    if (!product || !product.options || !product.variants) return null;

    var selected = product.options.map(function (optName) {
      var name = (typeof optName === 'object') ? optName.name : optName;
      var checked = form.querySelector('input[name="options[' + name + ']"]:checked');
      if (checked) return checked.value;
      var select = form.querySelector('select[name="options[' + name + ']"]');
      if (select) return select.value;
      return null;
    });

    if (selected.indexOf(null) !== -1) return null;

    return product.variants.filter(function (v) {
      return v.options.length === selected.length && v.options.every(function (val, i) {
        return val === selected[i];
      });
    })[0] || null;
  }

  /* ── Swap image avec fondu (préchargement → fade out → src → fade in) ────── */
  function swapHeroImage(img, src, srcset, alt) {
    if (!img || !src) return;
    var preload = new Image();
    preload.onload = function () {
      img.style.transition = 'opacity ' + FADE_MS + 'ms ease';
      img.style.opacity = '0';
      window.setTimeout(function () {
        img.src = src;
        if (srcset) img.srcset = srcset; else img.removeAttribute('srcset');
        if (alt) img.alt = alt;
        img.style.opacity = '1';
      }, FADE_MS);
    };
    preload.onerror = function () {
      console.warn(LOG, 'préchargement image variante échoué :', src);
    };
    preload.src = src;
  }

  /* ── Mise à jour de l'URL (?variant=) sans reload ────────────────────────── */
  function updateUrl(variantId) {
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {
      console.warn(LOG, 'replaceState impossible :', e);
    }
  }

  /* ── Init ───────────────────────────────────────────────────────────────── */
  function init(product) {
    var form = findForm();
    if (!form) { console.warn(LOG, 'form produit introuvable — sync couleur désactivée.'); return; }

    var lastVariantId = null;

    function onChange() {
      var variant = getSelectedVariant(product, form);
      if (!variant || variant.id === lastVariantId) return;
      lastVariantId = variant.id;

      updateUrl(variant.id);

      var fi = variant.featured_image;
      if (fi && fi.src) {
        var img = findHeroImage();
        if (!img) {
          console.warn(LOG, 'image héro introuvable — swap ignoré (URL/event quand même mis à jour).');
        } else {
          var src = fi.src.indexOf('?') === -1 ? fi.src + '?width=1200' : fi.src;
          swapHeroImage(img, src, '', fi.alt);
        }
      } else {
        console.warn(LOG, 'variante sans featured_image, image héro inchangée :', variant.id);
      }

      document.dispatchEvent(new CustomEvent('ypersoa:variant-change', { detail: variant }));
    }

    form.addEventListener('change', onChange);
  }

  function boot() {
    loadProduct()
      .then(init)
      .catch(function (e) { console.warn(LOG, 'sync couleur non initialisée :', e.message); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
